import React from 'react';

interface TemplateDebugInfoProps {
  debugInfo: any;
  className?: string;
  title?: string;
}

/**
 * Component to display debug information about a template
 */
export function TemplateDebugInfo({
  debugInfo,
  className = '',
  title = 'Debug Info',
}: TemplateDebugInfoProps) {
  if (!debugInfo) {
    return null;
  }

  return (
    <div className={`p-4 bg-gray-100 rounded ${className}`}>
      <h2 className="font-medium mb-2">{title}:</h2>
      <pre className="text-xs overflow-auto max-h-[200px]">
        {JSON.stringify(debugInfo, null, 2)}
      </pre>
    </div>
  );
} 